const module = {
  config: {
    name: 'daftar-aduan',
    icon: 'ri-menu-5-line',
    desc: 'Data Aduan SEKAR',
    layout: true
  },
  routes: [
    { name: 'allegations', label: 'Daftar Aduan', icon: null, path: '/allegations', component: () => import('./allegations.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/aduan/_index.js